import { cssNumber } from "jquery";

function generateSelectOperationOnExamplePreLoad(example, treeFieldList)
{
    var checkedItems = [];
    if(example != undefined && example != null)
    {
        checkedItems = iterateExampleAndGenerateCheckedItems(example,undefined,checkedItems);
    }
    return getSortedOrderOfCheckedItems(checkedItems,treeFieldList);
}

function iterateExampleAndGenerateCheckedItems(schema,parent,checkedItems)
{
    for (var property in schema)
    {
        if(typeof schema[property] == "object" && !Array.isArray(schema[property]))
        {
            var contents = "";
            if(parent == undefined)
            {
              contents = property;
            }
            else
            {
              contents = parent + "-" + property;
            }
            iterateExampleAndGenerateCheckedItems(schema[property],contents,checkedItems);
        }
        else if(Array.isArray(schema[property]))
        {
            var contents = "";
            if(parent == undefined)
            {
              contents = property;
            }
            else
            {
              contents = parent + "-" + property;
            }
            if(typeof schema[property][0] == "object" || Array.isArray(schema[property][0])){
                iterateExampleAndGenerateCheckedItems(schema[property][0],contents,checkedItems);
            }
            else{
                checkedItems.push(contents.replaceAll('_','*'));
            }
        }
        else
        {
            var childElement = "";
            if(parent == undefined)
            {
                childElement = property;
            }
            else
            {
                childElement = parent + "-" + property;
            }
            checkedItems.push(childElement.replaceAll('_','*'));
        }
    }
    return checkedItems;
}

function getSortedOrderOfCheckedItems(checkedItems, treeFieldList){
    for(var fieldIndex in treeFieldList){
        var field = treeFieldList[fieldIndex];
        for(var itemIndex in checkedItems){
            var checkedItem = checkedItems[itemIndex];
            if(field == checkedItem){
                treeFieldList[fieldIndex] = treeFieldList[fieldIndex] + '0';
                break;
            }
        }
    }
    var newCheckedItems = [];
    for(var fieldIndex in treeFieldList){
        var field = treeFieldList[fieldIndex];
        if(field.charAt(field.length-1) == '0'){
            newCheckedItems.push(field.substring(0,field.length-1));
        }
    }
    return newCheckedItems;
}

function addItemsToJsonTree(path,exampleValue,newExampleValue,jsTreeContents)
{
    var pathValue = path.replaceAll('*','_').split("-");
    if(pathValue.length >0)
    {
        newExampleValue = iterateExampleValueAndAddKey(pathValue,0,exampleValue,newExampleValue,jsTreeContents);
    }
   
    return newExampleValue;   
}

function iterateExampleValueAndAddKey(pathValue,iterator,exampleValue,newExampleValue,jsTreeContents)
{
    if(pathValue.length >iterator)
    {
        var jsTreeElement = getIndexOfJsTree(jsTreeContents,pathValue[iterator]);
        if(exampleValue !=null && pathValue[iterator] != null && jsTreeContents[jsTreeElement]!=null)
        {
            var object = getObjectOfJsTree(jsTreeContents,pathValue[iterator]);
            if(exampleValue[pathValue[iterator]] == undefined)
            {
                if(object["type"] == "object")
                {
                    exampleValue[pathValue[iterator]] = {};
                    newExampleValue[pathValue[iterator]] = {};   
                }
                else if(object["type"] == "array")
                {
                    if("children" in jsTreeContents[jsTreeElement]){
                        newExampleValue[pathValue[iterator]] = [{}];
                        exampleValue[pathValue[iterator]] = [{}];   
                    }
                    else{
                        newExampleValue[pathValue[iterator]] = [];
                        exampleValue[pathValue[iterator]] = [];   
                    }
                }
                else
                {
                    newExampleValue[pathValue[iterator]] = "";
                }
            }
            else{
                if(object["type"] == "object"){
                    if(newExampleValue[pathValue[iterator]] == undefined){
                        newExampleValue[pathValue[iterator]] = {}
                    }
                }
                else if(object["type"] == "array"){
                    if(newExampleValue[pathValue[iterator]] == undefined){
                        if("children" in jsTreeContents[jsTreeElement]){
                            newExampleValue[pathValue[iterator]] = [{}];
                        }
                        else{
                            newExampleValue[pathValue[iterator]] = exampleValue[pathValue[iterator]];
                        }
                    }
                }
                else{
                    newExampleValue[pathValue[iterator]] = exampleValue[pathValue[iterator]];
                }
            }

            if("children" in jsTreeContents[jsTreeElement] && jsTreeContents[jsTreeElement]["type"] == "object")
            {
                iterateExampleValueAndAddKey(pathValue,(iterator+1),exampleValue[pathValue[iterator]],newExampleValue[pathValue[iterator]],jsTreeContents[jsTreeElement]["children"]);
            }
            else if("children" in jsTreeContents[jsTreeElement] && jsTreeContents[jsTreeElement]["type"] == "array")
            {
                iterateExampleValueAndAddKey(pathValue,(iterator+1),exampleValue[pathValue[iterator]][0],newExampleValue[pathValue[iterator]][0],jsTreeContents[jsTreeElement]["children"]);
            }
        }   
    }
    return newExampleValue;
}

function removeItemsToJsonTree(path,exampleValue,parent,jsTreeContents)
{
    var pathValue = path.replaceAll('*','_').split("-");
    if(pathValue.length >0)
    {
        exampleValue = iterateExampleValueAndRemoveKey(pathValue,0,exampleValue,jsTreeContents);
    }
   
    return exampleValue;   
}

function iterateExampleValueAndRemoveKey(pathValue,iterator,exampleValue,jsTreeContents)
{
    if(pathValue.length >iterator)
    {
        var jsTreeElement = getIndexOfJsTree(jsTreeContents,pathValue[iterator]);
        if(exampleValue !=null && pathValue[iterator] != null && jsTreeContents[jsTreeElement]!=null)
        {
            if(pathValue.length -1 == iterator)
            {
                if(exampleValue.hasOwnProperty(pathValue[iterator]))
                {
                    delete exampleValue[pathValue[iterator]];
                }
            }

            if("children" in jsTreeContents[jsTreeElement] && jsTreeContents[jsTreeElement]["type"] == "object")
            {
                iterateExampleValueAndRemoveKey(pathValue,(iterator+1),exampleValue[pathValue[iterator]],jsTreeContents[jsTreeElement]["children"]);
            }
            else if("children" in jsTreeContents[jsTreeElement] && jsTreeContents[jsTreeElement]["type"] == "array")
            {
                iterateExampleValueAndRemoveKey(pathValue,(iterator+1),exampleValue[pathValue[iterator]][0],jsTreeContents[jsTreeElement]["children"]);
            }
            if(exampleValue[pathValue[iterator]] != undefined)
            {
                if(exampleValue[pathValue[iterator]][0] && isEmptyObject(exampleValue[pathValue[iterator]][0])){
                    delete exampleValue[pathValue[iterator]];
                }
                else if(isEmptyObject(exampleValue[pathValue[iterator]]))
                {
                    if(exampleValue.hasOwnProperty(pathValue[iterator]))
                    {
                        delete exampleValue[pathValue[iterator]];
                    }
                }
            }
        }   
    }
    return exampleValue;
}

function isEmptyObject(value) {
    return (Object.keys(value).length === 0 && value.constructor === Object);
  }


function getIndexOfJsTree(jsTreeContents,label)
{   
    for(var element in jsTreeContents)
    {    
        var elementLabel = "";
        if(typeof jsTreeContents[element]["label"] == "object"){
            elementLabel = jsTreeContents[element]["label"].props.children[0].trim();
        }
        if(jsTreeContents[element]["label"] == label || elementLabel == label)
        {
           return element;
        }
    }
    return null;
}

function getObjectOfJsTree(jsTreeContents,label)
{   
    for(var element in jsTreeContents)
    {    
        var elementLabel = "";
        if(typeof jsTreeContents[element]["label"] == "object"){
            elementLabel = jsTreeContents[element]["label"].props.children[0].trim();
        }
        if(jsTreeContents[element]["label"] == label || elementLabel == label)
        {
           return jsTreeContents[element];
        }
    }
    return null;
}

function compareTwoArraysAndRemoveDuplicates(array1 ,array2)
{
    var index;
    for (var i=0; i<array2.length; i++) {
        index = array1.indexOf(array2[i]);
        if (index > -1) {
            array1.splice(index, 1);
        }
    }
    return array1;
}

// serailize data string before sending
function iterateJsonAndGetPrimitiveJson(schema, obj) {
    for (var property in obj) {
        if (obj.hasOwnProperty(property)) {
            if (typeof obj[property] == "object" && obj[property] != null && obj[property].length == undefined) {
                iterateJsonAndGetPrimitiveJson(schema[property]["properties"], obj[property]);
            } else {
                if(schema != undefined)
                {
                    if(schema[property] != undefined)
                    {
                        if(schema[property]["type"] != undefined)
                        {
                            if (schema[property]["type"].toLowerCase() == "boolean") {
                                if ((obj[property] == true)) {
                                    obj[property] = new Boolean(true);
                                } else {
                                    obj[property] = new Boolean(false);
                                }
                            } else if ((schema[property]["type"].toLowerCase() == "number")) {
                                obj[property] = Number(obj[property]);
                            } else if ((schema[property]["type"].toLowerCase() == "integer")) {
                                obj[property] = parseInt(obj[property]);
                            }
                        }
                    }
                }
            }
        }
    }
    return obj;
}
export default generateSelectOperationOnExamplePreLoad;
export {generateSelectOperationOnExamplePreLoad,iterateExampleAndGenerateCheckedItems,addItemsToJsonTree,removeItemsToJsonTree,compareTwoArraysAndRemoveDuplicates,iterateJsonAndGetPrimitiveJson};